export const lasaguas = {
	nombre: "Las Aguas",
	dia: "Miércoles Santo",
	nombrecompleto:
		"Real, Gremial, Nacional y Marianista Hermandad Sacramental del Santísimo Cristo de las Aguas, Nuestra Señora de la Luz y Asociación de Discípulos de San Juan Evangelista y María Stma. de Guadalupe",
	sede: "Iglesia de Nuestra Señora del Pilar, Colegio San Felipe Neri",
	pasos: 2,
	distancia: [1120, 1710],
	penitentes: 225,
	cargadores: 120,
	web: "http://www.diariodecadiz.es/semana_santa/Aguas_0_1229277817.html",

	ida: [
		{ lng: -6.29444, lat: 36.52858 },
		{ lng: -6.29458, lat: 36.5286505 },
		{ lng: -6.294875, lat: 36.5281731 },
		{ lng: -6.2958956, lat: 36.5286344 },
		{ lng: -6.295512, lat: 36.5295913 },
		{ lng: -6.2946296, lat: 36.5294103 },
		{ lng: -6.2945183, lat: 36.5299426 },
		{ lng: -6.2943439, lat: 36.5305558 },
		{ lng: -6.2940516, lat: 36.5305784 },
		{ lng: -6.2935084, lat: 36.5307325 },
		{ lng: -6.292917, lat: 36.5310795 },
		{ lng: -6.2922062, lat: 36.5302961 },
		{ lng: -6.2928177, lat: 36.5297928 },
		{ lng: -6.2930551, lat: 36.5298068 },
		{ lng: -6.2932885, lat: 36.5297357 },
		{ lng: -6.2937203, lat: 36.5297012 },
		{ lng: -6.2945598, lat: 36.5296387 },
		{ lng: -6.2946162, lat: 36.5293715 },
		{ lng: -6.2951271, lat: 36.529476 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956864, lat: 36.5290773 },
		{ lng: -6.2954047, lat: 36.5297433 },
		{ lng: -6.2956703, lat: 36.5299609 },
		{ lng: -6.2952867, lat: 36.5303316 },
		{ lng: -6.2950131, lat: 36.5308338 },
		{ lng: -6.2949246, lat: 36.5308446 },
		{ lng: -6.2949327, lat: 36.5314567 },
		{ lng: -6.2965071, lat: 36.5317843 },
		{ lng: -6.2964213, lat: 36.5318834 },
		{ lng: -6.2967995, lat: 36.5325375 },
		{ lng: -6.296432, lat: 36.5329168 },
		{ lng: -6.2962684, lat: 36.5332369 },
		{ lng: -6.2963489, lat: 36.5333015 },
		{ lng: -6.296314, lat: 36.5333651 },
		{ lng: -6.2962724, lat: 36.5339309 },
		{ lng: -6.2954812, lat: 36.5340192 },
		{ lng: -6.292178, lat: 36.5302896 },
		{ lng: -6.2928151, lat: 36.5297745 },
		{ lng: -6.2930538, lat: 36.5297939 },
		{ lng: -6.2933334, lat: 36.529705 },
		{ lng: -6.2933874, lat: 36.5294046 },
		{ lng: -6.2932393, lat: 36.529387 },
		{ lng: -6.2932854, lat: 36.5291405 },
		{ lng: -6.2938197, lat: 36.5291951 },
		{ lng: -6.2938521, lat: 36.5291394 },
		{ lng: -6.2941108, lat: 36.529169 },
		{ lng: -6.294222, lat: 36.5288206 },
		{ lng: -6.294519, lat: 36.5287536 },
		{ lng: -6.2945696, lat: 36.5286673 },
		{ lng: -6.2944405, lat: 36.5285993 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-28T15:45",
			latlng: [36.53306, -6.2965]
		},
		{
			name: "Nueva",
			hora: "2018-03-28T17:45",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-28T18:45",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-28T19:45",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-28T20:20",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-28T20:35",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Jesus de Medinaceli",
			"Plaza de Fray Félix",
			"Stmo. Cristo del Perdón",
			"Campo del Sur",
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Cobos",
			"Cristóbal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena", "Valverde"],
		[
			"Beato Diego Jose de Cadiz",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva",
			"Plaza de San Juan de Dios",
			"Pomponio Mela",
			"San Antonio Abad",
			"Posadilla",
			"Plaza San Martín",
			"Obispo José María Rancés",
			"Plaza de Fray Félix",
			"Jesus de Medinaceli"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/lasaguas.js